'use client';
import SafeLink from '@/components/SafeLink';
import CDNImage from '@/components/cdnImage/cdnImage';
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';
import style from './style.module.scss';

export default function Module({ moduleData, pageName }: { moduleData: any; pageName: string }) {
  const PageConfig: any = {};
  const initConfig = (moduleData: any) => {
    PageConfig.data = moduleData.dataBatch?.brandConfig?.filter((item: any) => item.brand) || [];
    PageConfig.title = moduleData.dataStyle?.title.title || '';
    PageConfig.moduleCode = moduleData.moduleCode || ''; // 动态获取类名
  };

  initConfig(moduleData);

  if (!PageConfig.data) {
    return null;
  }

  // 根据数据长度判断使用单行 || 双行布局
  const isSingleRow =
    PageConfig.moduleCode === 'big-1-explore-brands' ||
    (PageConfig.moduleCode === 'big-2-explore-brands' && PageConfig.data.length < 8);
  const gridTemplateRows = isSingleRow ? '130px' : 'repeat(2, 130px)';

  return (
    <div className={PageConfig.moduleCode ? style[PageConfig.moduleCode] : ''}>
      {PageConfig.title ? (
        <>
          <div className={style.header}>
            <div className={style.title}>{PageConfig.title}</div>
          </div>
        </>
      ) : null}

      {/* 双行滚动容器结构 */}
      <div
        className={style.scrollContainer}
        // style={{ paddingTop: PageConfig.title ? '0' : '12px' }}
      >
        <div className={style.scrollContent} style={{ gridTemplateRows }}>
          {PageConfig.data.map((item: any, index: any) => (
            <SafeLink
              href={`/store/${item.brand.shopId}`}
              key={item.brand.shopId}
              onClick={(e) => {
                spmTrackingUtils.spmClick({
                  spm: `a0145.b002244.c00002472.${index + 1}`,
                  page_id: 'Mini_Hp',
                  event_id: 'Home_Mini_Hp_Brands',
                  target: e.target as HTMLElement,
                  json_param: JSON.stringify({
                    index: index,
                    shopid: item.brand.shopId,
                    brandid: '-100',
                    Mini_Hp_Name: pageName || 'home',
                  }),
                });
              }}
            >
              <div
                className={style.item}
                key={index}
                data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
                data-exp={JSON.stringify({
                  spm: `a0145.b002244.c00002472.${index + 1}`,
                  page_id: 'Mini_Hp',
                  event_id: 'Home_Mini_Hp_Brands_Expo',
                  json_param: {
                    index: index,
                    shopid: item.brand.shopId,
                    brandid: '-100',
                    Mini_Hp_Name: pageName || 'home',
                  },
                })}
              >
                <div className={style.bg}>
                  <div>
                    <CDNImage
                      src={item?.brandImg?.imageUrl}
                      width={item?.brandImg?.imageWidth}
                      height={item?.brandImg?.imageHeight}
                      alt={item?.brand}
                    />
                  </div>
                  <div className={style.text}>{item?.brand?.shopName}</div>
                  <div className={style.positionImg}>
                    <CDNImage
                      src={item?.brand?.shopIcon}
                      width={32}
                      height={32}
                      alt={item?.cateName}
                    />
                  </div>
                </div>
              </div>
            </SafeLink>
          ))}
        </div>
      </div>
    </div>
  );
}
